<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/RechargeList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>汇率配置</el-breadcrumb-item>
          <el-breadcrumb-item>汇率配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="8" class="display-row">
            <div class="query-title">警告词:</div>
            <div class="flex1">
              <el-input v-model="queryInfo.name" size="small"></el-input>
            </div>
          </el-col>

          <el-col :span="16" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
              <el-button class="search-btn btn-green" @click="addOrEdit('新增',{})">新增</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :data="recordList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border
          v-loading="isLoading" height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column prop="name" align="center" label="警告词">
          </el-table-column>
          <el-table-column prop="remark" align="center" label="备注">
          </el-table-column>
          <el-table-column prop="exchangeRate" align="center" label="启用状态">
            <template v-slot="{row}">
              <el-switch
                  v-model="row.enabled"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
                  active-text="启用"
                  @change="handleChange(row)"
                  inactive-text="禁用">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column width="130" label="操作">
            <template v-slot="{row}">
              <el-button type="primary" plain @click="addOrEdit('编辑',row)" size="small">编辑</el-button>
              <el-button type="danger" @click="handleDelete(row)" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  // name: 'capitalRecord/ExchangeRate',
  name: 'shopBlackList',
  components: { tableCon },
  data () {
    return {
      isLoading: false,
      queryInfo: {
        name: '',
        pageSize: 10,
        pageNum: 1
      },
      recordList: [],
      total: 0,
    }
  },
  methods: {
    // 新增编辑
    addOrEdit (title,row) {
      this.$modalDialog(() => import('./components/shop-dialog.vue'), {
        title,row
      }).then(
          () => {
            this.getrecordList();
          },
          () => {
          }
      )
    },
    async handleChange(row){
      console.log(row)
      const params = { ...row }
      const res = await this.$http.post('keywordBlacklist/updateAction', params);
      if(res.data.code == 200){
        this.$message({
          message: res.data.message,
          type: 'success'
        });
        await this.getrecordList();
      }
    },
    // 删除
    async handleDelete(row){
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post(`keywordBlacklist/deleteByIds?ids=${row.id}`);
        if(res.data.code == 200){
          this.$message({
            message: res.data.message,
            type: 'success'
          });
          await this.getrecordList();
        }else {
          this.$message({
            message: res.data.message,
            type: 'error'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    searchList () {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    async getrecordList () {
      this.isLoading = true
      const { data: res } = await this.$http.get('keywordBlacklist/list', { params: this.queryInfo });
      this.isLoading = false
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear () {    //清空
      this.queryInfo = {
        rechargeNo: '',
        pageSize: 10,
        pageNum: 1
      }
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
  },
  created () {
    this.getrecordList();
  }
};
</script>

<style lang="less" scoped>
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
